
export default {
  name: 'BackArrow',
  props: {
    color: {
      type: String,
      default: '#009FD4',
    },
  },
};
